/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const QualityBarChart = ({
  labels = ["Jan",],
  datasets = [],
  Heading = "",
  height = "200px",
  title = '',
}) => {

  const chartData = {
    labels,
    datasets: datasets.map((dataset) => ({
      ...dataset,
      borderRadius: 4,
      barPercentage: 0.8,
      categoryPercentage: 0.5,
    })),
  };

  const allValues = datasets.flatMap(ds => ds.data);
  const maxValue = Math.max(...allValues, 0);
  const dynamicMax = Math.ceil(maxValue / 10) * 10;

  // const options = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   plugins: {
  //     datalabels: {
  //       anchor: 'end',
  //       align: 'end',
  //       clamp: true, 
  //       offset: 5,
  //       font: {
  //         size: 12,
  //         weight: 'bold',
  //       },
  //       color: '#000',
  //     },
  //     title: {
  //       display: !!title,
  //       text: title,
  //     },
  //     legend: {
  //       position: 'bottom',
  //       labels: {
  //         usePointStyle: true,
  //         pointStyle: 'circle',
  //         padding: 20,
  //       },
  //     },
  //     tooltip: {
  //       enabled: true,
  //     },
  //     datalabels: {
  //       display: true,
  //       anchor: "end",
  //       align: "end",
  //       color: "#3c3b3bff",
  //       font: {
  //           size: 9,
  //           weight: "bold",
  //           family: "Roboto",
  //         },
  //     }
  //   },
  //   scales: {
  //     x: {
  //       grid: {
  //         display: true,
  //       },
  //     },
  //     y: {
  //       beginAtZero: true,
  //       min: 0,
  //       max: dynamicMax,
  //       ticks: {
  //         precision: 0,
  //         // stepSize: 4,
  //       },
  //       grid: {
  //         display: true,
  //       },
  //     },
  //   },
  // };

  const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    datalabels: {
      display: true,
      anchor: "end",
      align: "end",
      clamp: true,
      offset: 4,
      color: "#3c3b3bff",
      font: {
        size: 9,
        weight: "bold",
        family: "Roboto",
      },
    },
    title: {
      display: !!title,
      text: title,
    },
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 20,
      },
    },
    tooltip: {
      enabled: true,
    },
  },

  // <<< ADD THIS HERE
  layout: {
    padding: {
      top: 25,
    },
  },

  scales: {
    x: {
      grid: {
        display: true,
      },
    },
    y: {
      beginAtZero: true,
      min: 0,
      max: dynamicMax,
      ticks: {
        precision: 0,
      },
      grid: {
        display: true,
      },
    },
  },
};


  return (
    <div style={{ width: '100%', height: height }}>
      <div className='d-flex justify-content-center'> <h6>{Heading}</h6>
      </div>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default QualityBarChart;
